import classNames from 'classnames';
import React from 'react';

const PrimaryButton = ({
  onClick,
  title,
  isLoading,
  fullWidth,
  disabled,
}) => (
  <button
    className={classNames('button button--primary', { 'button--full': fullWidth })}
    disabled={disabled || isLoading}
    onClick={onClick}
    data-testid="primary-button"
    type="submit"
  >
    {!isLoading ? title : <div className="button__loader" />}
  </button>
);

export default PrimaryButton;
